import { readonly, ref } from 'vue';
import type { AccountTag } from '@/shared/api/tags';
import { DomPurify } from '@/shared/legacy/lib/dom-purify/dom-purify';
import { stringToIndex } from '@/shared/legacy/lib/util/search';
import { compareByName } from '@/shared/legacy/lib/compators/compators';

// Sanitize tags
const sanitizeTags = (tags: Array<AccountTag>) => {
  return tags.map((tag) => {
    return {
      ...tag,
      name: sanitizeTagName(tag.name),
      _index: stringToIndex(tag.name)
    };
  });
};

export function sanitizeTagName(name: string) {
  return DomPurify.sanitize(name, {
    ALLOWED_TAGS: [],
    USE_PROFILES: false
  });
}

function makeAccountTagsConfig() {
  const accountTags = ref<Array<AccountTag>>();

  const readonlyAccountTags = readonly(accountTags);
  return {
    accountTags: readonlyAccountTags,
    setAccountTags: (items: AccountTag[], withSort = true) => {
      if (!items.length) {
        accountTags.value = [];
        return [];
      }
      const value = sanitizeTags(items).sort(withSort ? compareByName : () => 0);
      accountTags.value = value;
      return value;
    }
  };
}

export const accountTags = makeAccountTagsConfig();
